module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_04-dd387e3412c849de889df58d8417e2bb.png";